import { render, staticRenderFns } from "./CheckboxLikeRadio.vue?vue&type=template&id=16de2b5f&"
import script from "./CheckboxLikeRadio.vue?vue&type=script&lang=js&"
export * from "./CheckboxLikeRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports